export enum QueryKey {
  BULK_STAKEHOLDER_ACTIONS = 'bulk-stakeholder-actions',
  CHANGE_SUBSCRIPTION = 'change-subscription',
  CREATE_PUBLIC_HOLIDAY = 'create-public-holiday',
  CREATE_SUBSCRIPTION_OFFER = 'create-subscription-offer',
  CREATE_TEAM_MEMBER = 'create-team-member',
  CREATE_VACATION = 'create-vacation',
  DEACTIVATE_COMPANY = 'deactivate-company',
  DELETE = 'delete',
  DELETE_PUBLIC_HOLIDAY = 'delete-public-holiday',
  DELETE_STAKEHOLDER = 'delete-stakeholder',
  DELETE_SUBSCRIPTION_OFFER = 'delete-subscription-offer',
  DELETE_TEAM_MEMBER = 'delete-team-member',
  DELETE_VACATION = 'delete-vacation',
  GET = 'get',
  GET_BASIC_PLANS = 'get-basic-plans',
  GET_COMPANIES = 'get-companies',
  GET_COMPANY = 'get-company',
  GET_COMPANY_ADMIN_STAKEHOLDER = 'get-company-admin-stakeholder',
  GET_NOTIFICATIONS = 'get-notifications',
  GET_PUBLIC_HOLIDAYS = 'get-public-holidays',
  GET_REGION = 'get-region',
  GET_STAKEHOLDER = 'get-stakeholder',
  GET_STAKEHOLDERS = 'get-stakeholders',
  GET_SUBSCRIPTION_DATA = 'get-subscription-data',
  GET_SUBSCRIPTION_OFFERS = 'get-subscription-offers',
  GET_TEAM_MEMBERS = 'get-team-members',
  GET_UNREAD_NOTIFICATION_COUNT = 'get-unread-notification-count',
  GET_VACATIONS = 'get-vacations',
  MARK_NOTIFICATION_AS_READ = 'mark-notification-as-read',
  MARK_NOTIFICATION_AS_RESOLVED = 'mark-notification-as-resolved',
  PATCH = 'patch',
  PATCH_STAKEHOLDER_ROLE = 'patch-stakeholder-role',
  PERKS = 'perks',
  POST = 'post',
  SCAN_CAP_TABLE = 'scan-cap-table',
  TOGGLE_STAKEHOLDER_ACCESS = 'toggle-stakeholder-access',
  UPDATE_PUBLIC_HOLIDAY = 'update-public-holiday',
  UPDATE_SUBSCRIPTION_OFFER = 'update-subscription-offer',
  UPDATE_TEAM_MEMBER = 'update-team-member',
  UPDATE_VACATION = 'update-vacation',
}
